module.exports = __webpack_public_path__ + "static/media/arrow_right_black.cac50139.png";